import React from 'react';

const fmt = (v) => `${Number.isInteger(Number(v)) ? Number(v) : Number(v).toFixed(2)}€`;

export const promoPct = (p) => (p.discount_type === 'percentage'
  ? Math.round(p.discount_value)
  : Math.round((1 - p.final_price / Math.max(1, p.base_price)) * 100));

/** Promo yield d'un créneau (joueurs payants) : badge « Promo −X % » + ancien prix barré. */
export const SlotPromoBadge = ({ promo, testId, withPrice = true }) => (
  <span className="inline-flex items-center gap-1 whitespace-nowrap" title={promo.label} data-testid={testId}>
    <span className="px-1.5 py-0.5 rounded bg-[#D4AF37] text-white text-[10px] font-bold leading-none">Promo −{promoPct(promo)}%</span>
    <span className="line-through text-neutral-500 text-[10px] font-medium" data-testid={`${testId}-old`}>{fmt(promo.base_price)}</span>
    {withPrice && <span className="text-[10px] font-semibold text-[#8B4513]" data-testid={`${testId}-new`}>{fmt(promo.final_price)}</span>}
  </span>
);
